module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGElEQVQoU2NUbf/7n4EIwDiqEF8oUT94ACAeGpv2+0MvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/resource-icon-juxing.png
// module id = fhPY
// module chunks = 2